/* eslint-disable camelcase */
import React, { useState } from 'react';
import StarBorderIcon from '@material-ui/icons/StarBorder'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import NotificationsOutlinedIcon from '@material-ui/icons/NotificationsOutlined'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EmojiEventsOutlined from '@material-ui/icons/EmojiEventsOutlined';
import { useTranslation } from 'react-i18next';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import SvgIcon from '@material-ui/core/SvgIcon'
import * as OkrPopIpActions from '../../../actions/okr_popup.action';
import { WbEventHandlerMixins, RelationshipMapTypes } from '../../../../utils/common';
import { okrDetailConstants } from '../../../../constants/okr/okrDetails.constants';
import KrService from '../../../services/kr.service';
import GoalService from '../../../../services/goal.services';
import GoalDeleteConfirmPopup from '../../../../components/popup/confirm_delete/goal';
import CopyLinkIcon from '../../../../vectors/copy-link.svg'
import RelationshipMapIcon from '../../../../vectors/relationship-map.svg'
import RequestFeedbackIcon from '../../../../vectors/request_feedback.svg'
import GiveFeedbackIcon from '../../../../vectors/give_feedback_new.svg'
import KeyResultIcon from '../../../../vectors/key-result.svg'


const krService = new KrService();
const goalService = new GoalService();
// hide add to biz review for now
const showAddToBizReview = false;
declare let toastr: any;

const OKRThreeDotMenuPopup = ({
    menuList, goals, anchorEl, handleClose, dispatch, updateMenuList
}: any) => {
    const [goalIdToDelete, setGoalIdToDelete] = useState('');
    const { t } = useTranslation();
    const {
        reopenOkr,
        closeGoal,
        copyGoal,
        deleteGoal,
        edit,
        giveBadge,
        id,
        meetingAgenda,
        oneOnOneAgenda,
        show_ping,
        requestFeedback
    } = menuList;
    const { addSelfRbr } = menuList;
    const isAdd = (typeof addSelfRbr === 'undefined' ? false : addSelfRbr.isAdd);

    const isEnabledNewFeedback = window?.wbConfig?.isEnabledNewFeedback ?? false;
    const isFeedbackDisabledCompletely = window?.wbConfig?.isFeedbackDisabledCompletely ?? false;

    const editGoal = (addKr = false) => {
        WbEventHandlerMixins.editGoal(goals, 'fromOKRPopup', addKr)
        dispatch(OkrPopIpActions.UpdateModal(false))
    }

    const reopenOkrClcik = () => {
        dispatch(OkrPopIpActions.UpdateModal(false));
        WbEventHandlerMixins.reopenOkr(goals)
    }

    const closeGoalClick = () => {
        dispatch(OkrPopIpActions.UpdateModal(false));
        WbEventHandlerMixins.closeGoal(goals);
    }

    const goalBadgeClick = () => {
        WbEventHandlerMixins.goalBadge(
            {
                teamId: goals?.team_id,
                goalOwner: goals?.owner,
                owner: goals?.owner,
                id
            },
            'OKR_PAGES'
        );
    }

    const goalRequestFeedbackClick = () => {
        WbEventHandlerMixins.goalRequestFeedback(
            {
                teamId: goals?.team_id,
                goalOwner: goals?.owner,
                owner: goals?.owner,
                id
            },
            'OKR_PAGES'
        );
    }

    const addRbr = () => {
        const contentId = document.getElementById('content');
        showLoaderWidget(contentId);
        const params = { myRbr: 1, goalId: addSelfRbr.goalId, userId: addSelfRbr.userId };
        krService.addRbrGoal(params).then((resp: any) => {
            if (resp.status === 200 || resp.status === 'success') {
                toastr.success(`${t('Objective was added to the RBR page.')}`)
                setTimeout(() => {
                    updateMenuList();
                    removeLoader();
                }, 2500)
            } else {
                removeLoader();
            }
        })
            .catch(err => {
                console.log(err);
                removeLoader();
            })
    }

    const handleDeleteGoal = async () => {
        try {
            await goalService.deleteObjective({ goalId: goalIdToDelete });
            window.wb_track('OKR_DELETE', {
                UserId: window.uData.user_id,
                OrgId: window.uData.org_id,
                Timestamp: Date.now(),
                ObjectiveId: goalIdToDelete,
                Source: 'OKR_Wizard',
                TeamId: goals.team_id,
                OwnerId: goals.owner,
            });

            setGoalIdToDelete('');

            const regex = /wb\/okrs\/objectives\/\d+/;
            if (regex.test(window.location.href)) {
                const pathSegments = window.location.href.split('/');
                const objectiveId = pathSegments[pathSegments.length - 1];
                if (objectiveId) {
                    const channel = new BroadcastChannel('okr:objectiveDeleted');
                    channel.postMessage(objectiveId);
                    window.closeGoalDetailsPopup?.();
                }
            } else {
                window.location.href = `${window.location.origin}/wb/okrs`;
            }
        } catch (e) {
            alert(t('Oops! something went wrong try again later! '))
        }
    }

    const semEnabled = window.wbConfig?.isSemEnabled ?? false;
    const isIndividualGoal = Number(goals?.type) === okrDetailConstants.GOAL_TYPE_INDIVIDUAL;

    return (
        <>
            <Menu
                className="kr-model-three-dot-menu"
                id="okr-long-menu"
                getContentAnchorEl={null}
                keepMounted
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleClose}
                onClick={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                disablePortal={false}
                container={() => document.body}
                MenuListProps={{
                    style: { maxHeight: 'none' }
                }}
                PaperProps={{
                    style: {
                        maxHeight: 'none',
                        overflow: 'visible'
                    }
                }}
            >
                {edit
                    ? (
                        <>
                            <MenuItem className="kr-kebab-submenu" onClick={() => editGoal()}>
                                <EditOutlinedIcon
                                    className="icon-outline-update-24px"
                                    fontSize="small"
                                    htmlColor="#687587"
                                />
                                <span data-testid="editSettings">{t('Edit Settings')}</span>
                            </MenuItem>
                            <MenuItem className="kr-kebab-submenu" onClick={() => editGoal(true)}>
                                <SvgIcon viewBox="0 2 20 20" component={KeyResultIcon} fontSize="small" htmlColor="#687587" />
                                <span data-testid="addKeyResult">{t('Add Key result')}</span>
                            </MenuItem>
                        </>
                    )
                    : ''}
                {showAddToBizReview && isAdd
                    ? (
                        <MenuItem className="kr-kebab-submenu" onClick={addRbr}>
                            <p className="okr_ws_tab_biz_review_icon">
                                <i className="icon icon-biz_review-24px " />
                            </p>
                            <span>{t('Add to Biz Review')}</span>
                        </MenuItem>
                    )
                    : ''}
                {closeGoal
                    ? (
                        <MenuItem className="kr-kebab-submenu" onClick={() => closeGoalClick()}>
                            <StarBorderIcon className="icon-outline-update-24px" fontSize="small" htmlColor="#687587" />
                            <span>{t('Close out OKR')}</span>
                        </MenuItem>
                    )
                    : ''}
                {reopenOkr
                    ? (
                        <MenuItem className="kr-kebab-submenu" onClick={() => reopenOkrClcik()}>
                            <AddCircleOutlineIcon
                                className="icon-outline-update-24px"
                                fontSize="small"
                                htmlColor="#687587"
                            />
                            <span>{t('Reopen OKR')}</span>
                        </MenuItem>
                    )
                    : ''}
                {copyGoal
                    ? (
                        <MenuItem
                            className="kr-kebab-submenu"
                            data-testid="copyAndReset"
                            onClick={() => WbEventHandlerMixins.copyGoal(goals)}
                        >
                            <FileCopyOutlinedIcon
                                className="icon-outline-update-24px"
                                fontSize="small"
                                htmlColor="#687587"
                            />
                            <span>{t('Copy & Reset OKR')}</span>
                        </MenuItem>
                    )
                    : ''}
                {show_ping
                    ? (
                        <MenuItem
                            className="kr-kebab-submenu"
                            onClick={() => WbEventHandlerMixins.pingGoal(goals)}
                        >
                            <NotificationsOutlinedIcon
                                className="icon-outline-update-24px"
                                fontSize="small"
                                htmlColor="#687587"
                            />
                            <span>{t('Ping For Update')}</span>
                        </MenuItem>
                    )
                    : ''}
                {semEnabled && !isIndividualGoal
                    ? (
                        <MenuItem
                            className="kr-kebab-submenu"
                            onClick={() =>
                                WbEventHandlerMixins.relationshipMapPage(RelationshipMapTypes.OBJECTIVE, goals.id, 'OKR_POPUP')
                            }
                        >
                            <SvgIcon viewBox="0 0 18 18" component={RelationshipMapIcon} fontSize="small" htmlColor="#687587" />
                            <span>Relationship map</span>
                        </MenuItem>
                    )
                    : ''}
                {giveBadge && !isFeedbackDisabledCompletely
                    ? (
                        <MenuItem
                            className="kr-kebab-submenu"
                            onClick={() => goalBadgeClick()}
                        >
                            {
                                isEnabledNewFeedback && !isFeedbackDisabledCompletely ?
                                    <span style={{ display: 'flex' }}>
                                        <SvgIcon
                                            fontSize='small'
                                            htmlColor='#687587'
                                            component={GiveFeedbackIcon}
                                            viewBox='0 0 20 17'
                                        />
                                    </span>
                                    : <EmojiEventsOutlined htmlColor='#687587' fontSize='small' />
                            }
                            <span>{t('Give Feedback')}</span>
                        </MenuItem>
                    )
                    : ''}
                {isEnabledNewFeedback && !isFeedbackDisabledCompletely && requestFeedback
                    ? (
                        <MenuItem
                            className="kr-kebab-submenu"
                            onClick={() => goalRequestFeedbackClick()}
                        >
                            <span style={{ display: 'flex' }}>
                                <SvgIcon
                                    fontSize='small'
                                    htmlColor='#687587'
                                    component={RequestFeedbackIcon}
                                    viewBox='0 0 19 17'
                                />
                            </span>
                            <span>{t('Request feedback')}</span>
                        </MenuItem>
                    )
                    : ''}
                {meetingAgenda
                    ? (
                        <MenuItem
                            className="kr-kebab-submenu"
                            onClick={() => WbEventHandlerMixins.meetingAgenda(goals)}
                        >
                            <AddCircleOutlineIcon
                                className="icon-outline-update-24px"
                                fontSize="small"
                                htmlColor="#687587"
                            />
                            <span>{t('Meeting Agenda')}</span>
                        </MenuItem>
                    )
                    : ''}
                {oneOnOneAgenda
                    ? (
                        <MenuItem
                            className="kr-kebab-submenu"
                            onClick={() => WbEventHandlerMixins.oneOnOneAgenda(goals)}
                        >
                            <AddCircleOutlineIcon
                                className="icon-outline-update-24px"
                                fontSize="small"
                                htmlColor="#687587"
                            />
                            <span>{t('Add To 1on1 Agenda')}</span>
                        </MenuItem>
                    )
                    : ''}
                <MenuItem className="kr-kebab-submenu" onClick={() => WBCopyToClipboard.objectiveUrl(goals?.id)}>
                    <SvgIcon viewBox="0 0 20 10" component={CopyLinkIcon} fontSize="small" htmlColor="#a6b6bc" />
                    <span>{t('Copy Link')}</span>
                </MenuItem>
                {typeof deleteGoal != 'undefined'
                    && deleteGoal
                    ? (
                        <MenuItem className="kr-kebab-submenu" onClick={() => setGoalIdToDelete(goals.id)}>
                            <DeleteOutlineIcon
                                className="icon-outline-update-24px"
                                fontSize="small"
                                htmlColor="#687587"
                            />
                            <span>{t('Delete')}</span>
                        </MenuItem>
                    )
                    : ''}
            </Menu>
            {goalIdToDelete && (
                <div role="button" tabIndex={0} onClick={e => e.stopPropagation()} onKeyDown={e => e.stopPropagation()}>
                    <GoalDeleteConfirmPopup
                        onClose={() => setGoalIdToDelete('')}
                        onConfirm={handleDeleteGoal}
                    />
                </div>
            )}
        </>
    )
}

export default React.memo(OKRThreeDotMenuPopup);
